//Init Wow Package
const WOW = require('wowjs');
window.wow = WOW;

